
import React from 'react'
import { Autocomplete, Chip, Grid, List, TextField, useTheme } from '@mui/material'
import { formatDayjsDateTime } from 'utils/formatDayjsDateTime'

const SubtaskSelector = ({ subtasks, onSubtaskSelected, selectedSubtask }) => {
  const theme = useTheme()
  const processedChecklistItems = subtasks?.map(item => ({
    ...item,
    name: item.label, // normalize to work with getOptionLabel
    identifier: 'Subtask',
    idColor: 'rgb(104, 202, 238)', // or whatever color you want
  }))

  // ?.sort((a, b) => {
  //   const aTime = new Date(a.timeCreated || a.createdTime || 0).getTime()
  //   const bTime = new Date(b.timeCreated || b.createdTime || 0).getTime()
  //   return bTime - aTime // Most recent first
  // })
  return (
    <Autocomplete
      value={selectedSubtask}
      options={processedChecklistItems}
      getOptionLabel={option => option.name || option.label || option.id || ''}
      onChange={(event, newValue) => {
        onSubtaskSelected(newValue)
      }}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={params => (
        <TextField
          {...params}
          label="Select Subtask"
          variant="outlined"
          sx={{
            '& .MuiInputBase-input': { color: theme.palette.text.primary },
            '& .MuiInputLabel-root': { color: theme.palette.text.primary },
            '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.text.primary },
          }}
        />
      )}
      renderOption={(props, option, { index }) => (
        <List
          {...(props as any)}
          key={`${option?.title ?? ''}-${index}-${option?.identifier ?? option.id}`}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
          }}
        >
          <Grid
            container
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <Grid item xs={5}>
              {option.name || option.title || option.label}
            </Grid>
            {option?.timeCreated ? (
              <Grid item xs={4} sx={{ color: theme.palette.text.secondary, fontSize: 14 }}>
                {formatDayjsDateTime(option?.timeCreated)}
              </Grid>
            ) : option?.createdTime ? (
              <Grid item xs={4} sx={{ color: theme.palette.text.secondary, fontSize: 14 }}>
                {formatDayjsDateTime(option?.createdTime)}
              </Grid>
            ) : null}
            {option?.identifier && (
              <Grid item xs={2} sx={{ color: option?.idColor, fontSize: 14 }}>
                {option?.identifier}
              </Grid>
            )}
            {option?.SK && option?.commentCount > 0 && (
              <Grid item xs={1}>
                <Chip label={option?.commentCount} sx={{ color: 'rgb(24, 144, 255)', fontSize: 18 }} />
              </Grid>
            )}
            <Grid item xs={1} />

            {/* {option?.notes?.length > 0 ? (
              <Grid item xs={1}>
                <Chip label={option.notes.length} sx={{ color: 'rgb(24, 144, 255)', fontSize: 18 }} />
              </Grid>
            ) : (
              <Grid item xs={1} />
            )} */}
          </Grid>
        </List>
      )}
    />
  )
}

export default SubtaskSelector
